<section class="hd-communication-cheat-sheet-page">
  <!-- Controls -->
  <e-card2 class="hd-communication-cheat-sheet-page__controls-card" padding="2">
    <div class="hd-communication-cheat-sheet-page__controls" aria-label="Communication cheat sheet controls">
      <e-hd-content-language-picker></e-hd-content-language-picker>

      <span class="hd-communication-cheat-sheet-page__divider"></span>

      <button type="button" class="hd-communication-cheat-sheet-page__control" (click)="print()" aria-label="Print de cheat sheet">
        <i eIcon icon="print"></i>
        <span>Print</span>
      </button>
    </div>
  </e-card2>

  @if (pageTitle()) {
    <h2 class="hd-communication-cheat-sheet-page__title">{{ pageTitle() }}</h2>
  }
  @if (pageSubtitle()) {
    <p class="hd-communication-cheat-sheet-page__subtitle">{{ pageSubtitle() }}</p>
  }

  <div class="hd-communication-cheat-sheet-page__deck">
    <!-- Verbindingslijnen poort → kaart (onder de kaarten, boven de panelen) -->
    <svg class="hd-communication-cheat-sheet-page__connectors" aria-hidden="true" focusable="false" preserveAspectRatio="none">
      @for (line of connectors(); track line.gate) {
        <line
          [attr.x1]="line.x1"
          [attr.y1]="line.y1"
          [attr.x2]="line.x2"
          [attr.y2]="line.y2"
          [attr.stroke]="line.color"></line>
      }
    </svg>

    <!-- Rij 1: Projector & metamorfische poorten (62, 23, 56) over de volle breedte -->
    <article class="voice-group voice-group--wide">
      <div class="voice-group__header">
        <h3 class="voice-group__title">{{ metamorphicGroup().title }}</h3>
        @if (metamorphicGroup().subtitle) {
          <p class="voice-group__subtitle">{{ metamorphicGroup().subtitle }}</p>
        }
        @if (metamorphicGroup().attention) {
          <p class="voice-group__hint">
            <span class="voice-group__hint-label">{{ attentionLabel() }}</span> {{ metamorphicGroup().attention }}
          </p>
        }
        @if (metamorphicGroup().solution) {
          <p class="voice-group__hint">
            <span class="voice-group__hint-label">{{ solutionLabel() }}</span> {{ metamorphicGroup().solution }}
          </p>
        }
      </div>
      <div class="voice-group__cards voice-group__cards--row">
        @for (card of metamorphicGroup().cards; track card.gate) {
          <div class="voice-card" [attr.data-gate]="card.gate" [style.background-color]="card.color">
            <div class="voice-card__header">
              <span class="voice-card__gate">{{ card.gate }}</span>
              <div class="voice-card__voice">
                <p class="voice-card__voice-keynote">{{ card.voiceKeynote }}</p>
                <p class="voice-card__voice-properties">{{ card.voiceProperties }}</p>
              </div>
            </div>
            <p class="voice-card__keynotes">{{ card.keynotes }}</p>
            <p class="voice-card__hint">
              <span class="voice-card__hint-label">{{ attentionLabel() }}</span> {{ card.attention }}
            </p>
            <p class="voice-card__hint">
              <span class="voice-card__hint-label">{{ solutionLabel() }}</span> {{ card.solution }}
            </p>
            <p class="voice-card__circuit">{{ card.circuit }}</p>
          </div>
        }
      </div>
    </article>

    <!-- Rij 2: drie doorlopende kolommen rond het centrale wiel-diagram -->
    <div class="hd-communication-cheat-sheet-page__columns">
      @for (column of columns(); track column.key) {
        <div class="hd-communication-cheat-sheet-page__column hd-communication-cheat-sheet-page__column--{{ column.key }}">
          @for (block of column.blocks; track blockKey(block)) {
            @if (block.group; as group) {
              <article class="voice-group">
                @if (group.title || group.subtitle || group.attention || group.solution) {
                  <div class="voice-group__header">
                    @if (group.title) {
                      <h3 class="voice-group__title">{{ group.title }}</h3>
                    }
                    @if (group.subtitle) {
                      <p class="voice-group__subtitle">{{ group.subtitle }}</p>
                    }
                    @if (group.attention) {
                      <p class="voice-group__hint">
                        <span class="voice-group__hint-label">{{ attentionLabel() }}</span> {{ group.attention }}
                      </p>
                    }
                    @if (group.solution) {
                      <p class="voice-group__hint">
                        <span class="voice-group__hint-label">{{ solutionLabel() }}</span> {{ group.solution }}
                      </p>
                    }
                  </div>
                }
                <div class="voice-group__cards">
                  @for (card of group.cards; track card.gate) {
                    <div class="voice-card" [attr.data-gate]="card.gate" [style.background-color]="card.color">
                      <div class="voice-card__header">
                        <span class="voice-card__gate">{{ card.gate }}</span>
                        <div class="voice-card__voice">
                          <p class="voice-card__voice-keynote">{{ card.voiceKeynote }}</p>
                          <p class="voice-card__voice-properties">{{ card.voiceProperties }}</p>
                        </div>
                      </div>
                      <p class="voice-card__keynotes">{{ card.keynotes }}</p>
                      <p class="voice-card__hint">
                        <span class="voice-card__hint-label">{{ attentionLabel() }}</span> {{ card.attention }}
                      </p>
                      <p class="voice-card__hint">
                        <span class="voice-card__hint-label">{{ solutionLabel() }}</span> {{ card.solution }}
                      </p>
                      <p class="voice-card__circuit">{{ card.circuit }}</p>
                    </div>
                  }
                </div>
              </article>
            } @else if (block.kind === 'wheel') {
              <div class="hd-communication-cheat-sheet-page__wheel">
                <img class="hd-communication-cheat-sheet-page__wheel-image"
                     [src]="wheelImage"
                     [alt]="wheelAlt()"
                     (load)="onWheelLoad()" />
              </div>
            } @else if (block.kind === 'note') {
              <aside class="throat-note">
                <p class="throat-note__text">{{ throatNote() }}</p>
              </aside>
            }
          }
        </div>
      }
    </div>
  </div>
</section>
